import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(12),
    padding: theme.spacing(2),
    backgroundColor: '#fff',
    borderRadius: '4px',
    border: 'solid 1px #cfd8dc',
  },
}));